import { useEffect } from 'react'
import { useAppStore } from '../store/appStore'

const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"]'

const isEditable = (target: EventTarget | null): boolean =>
    target instanceof Element && target.matches(EDITABLE_SELECTOR)

/**
 * Tracks whether any editable element in the app has focus and mirrors it
 * to appStore.isEditing. Consumers use the flag to postpone UI updates
 * that would overwrite in-progress user edits.
 */
export const useEditingTracker = () => {
    useEffect(() => {
        const onFocusIn = (e: FocusEvent) => {
            if (isEditable(e.target) && !useAppStore.getState().isEditing) useAppStore.setState({ isEditing: true })
        }
        // relatedTarget is the element receiving focus; moving between
        // editable fields must not drop the flag in the blur->focus gap
        const onFocusOut = (e: FocusEvent) => {
            if (!isEditable(e.relatedTarget) && useAppStore.getState().isEditing)
                useAppStore.setState({ isEditing: false })
        }

        document.addEventListener('focusin', onFocusIn)
        document.addEventListener('focusout', onFocusOut)
        return () => {
            document.removeEventListener('focusin', onFocusIn)
            document.removeEventListener('focusout', onFocusOut)
        }
    }, [])
}
